<app-form-group [name]="name" [errorMessages]="errorMessages">
  <div class="image-uploader" #formElement ngProjectAs=".form-element">
    <div class="preview-container">
      @if (isDefaultImage) {
        <div class="image-preview" [style.background-image]="currentThumbnail | secureBgImage: 'url' | async"></div>
      }
      @if (isCustomImage) {
        <div class="image-preview" [style.background-image]="currentBlob | secureBgImage: 'blob' | async"></div>
      }
      @if (isSecureThumbnail) {
        <div class="image-preview" [style.background-image]="currentThumbnail"></div>
      }
      @if (!isDefaultImage && !isCustomImage && !isSecureThumbnail) {
        <div class="image-preview"></div>
      }
    </div>

    <div class="title-container">
      <div class="title">
        {{ label }}
      </div>
      @if (imageWidthRestriction && imageHeightRestriction) {
        <div class="dimensions">Max width: {{ imageWidthRestriction }}px, Max height: {{ imageHeightRestriction }}px</div>
      }

      @if (additionalComment) {
        <div class="dimensions comment">
          {{ additionalComment }}
        </div>
      }
    </div>

    <div class="controls-container">
      <div class="button-group">
        <label
          class="button upload-button flex-1"
          [class.disabled]="buttonsDisabled"
          (click)="buttonsDisabled ? $event.preventDefault() : null"
        >
          {{ isSecureThumbnail || defaultThumbnail !== currentThumbnail ? 'Change image' : 'Select image' }}
          <input
            type="file"
            #fileinput
            (change)="onFileSelect($any($event), true)"
            [accept]="accept"
            class="fileinput"
            [disabled]="buttonsDisabled"
          />
          <input [name]="$any(name)" [(ngModel)]="currentThumbnail" #model="ngModel" hidden [disabled]="buttonsDisabled" />
        </label>
        <button
          class="button remove-image flex-1"
          type="button"
          (click)="removeSelectedImage()"
          [disabled]="!showRemoveButton || buttonsDisabled"
        >
          Remove image
        </button>
        <button
          class="button flex-1 reset-image"
          type="button"
          (click)="resetToDefaultImage()"
          [disabled]="!showResetToDefaultButton || buttonsDisabled"
        >
          {{ resetToDefaultButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</app-form-group>
